<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :sort-options="{
        enabled: false,
      }"
      :pagination-options="paginationOptions"
      mode="remote"
      @on-page-change="handlePageChanged"
      :totalRows="totalRows"
      :isLoading.sync="api['GET-AUDIENCES'].loading"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.label === 'View Activity Logs'">
          <span>
            <a href="#" v-on:click="handleLogsClicked(props.row)"
              >View Activity Logs</a
            ></span
          >
        </span>

        <span v-if="props.column.label === 'Number of Associated Campaigns'">
          <span>
            {{
              !props.formattedRow[props.column.field]
                ? 'N/A'
                : props.formattedRow[props.column.field] + ' - '
            }}</span
          >
          <span v-if="props.formattedRow[props.column.field]">
            <a href="#" v-on:click="handleViewCampaignsClicked(props.row)"
              >View Campaigns</a
            >
          </span>
        </span>

        <span v-else-if="props.column.label === 'Type'">
          <div class="d-flex">
            <span> {{ props.formattedRow[props.column.field] || 'N/A' }}</span>
            <div
              class="c__info"
              v-if="
                props.formattedRow[props.column.field] !== 'Global' &&
                  props.formattedRow[props.column.field]
              "
            >
              <div
                @click="handleViewScopeClicked(props.row)"
                style="height: 12px; width: 12px;"
                class="c__tooltip_container ml-2"
              >
                <img
                  src="../../../assets/icons/icon-search-blue.svg"
                  alt="View"
                />
                <span class="c__tooltip"
                  >View assigned
                  {{
                    props.formattedRow[props.column.field].toLowerCase()
                  }}s</span
                >
              </div>
            </div>
          </div>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <view-audience-availability-modal
      :visible="showAudienceAvailabilityModal"
      :data="viewAudienceData"
      :scopeDisplay="scopeDisplay"
      @close-modal="closeAudienceAvailabilityModal"
    ></view-audience-availability-modal>
    <audience-activity-log-modal
      :visible="showLogsModal"
      :data="activityLogs"
      @close-modal="closeActivityLogsModal"
    ></audience-activity-log-modal>
    <associated-campaigns-modal
      :visible="showCampaignsModal"
      :audience="campaignsModalAudience"
      @close-modal="closeCampaignsModal"
    ></associated-campaigns-modal>
  </div>
</template>
<script>
import {VueGoodTable} from 'vue-good-table';
import ApiCallMixin from '../../../mixins/ApiCallMixin';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import ViewAudienceAvailabilityModal from '../AudienceList/ViewAudienceAvailabilityModal.vue';
import AudienceActivityLogModal from './AudienceActivityLogModal.vue';
import AssociatedCampaignsModal from './AssociatedCampaignsModal.vue';
import {format} from 'date-fns';
import UtcToTimezone from '../../../helpers/UtcToTimezone';

export default {
  mixins: [ApiCallMixin],
  components: {
    VueGoodTable,
    ViewAudienceAvailabilityModal,
    AudienceActivityLogModal,
    AssociatedCampaignsModal,
  },
  data() {
    return {
      rows: [],
      showAudienceAvailabilityModal: false,
      viewAudienceData: [],
      scopeDisplay: null,
      activityLogs: [],
      showLogsModal: false,
      currentPage: 1,
      totalRows: 0,
      showCampaignsModal: false,
      campaignsModalAudience: null
    };
  },
  computed: {
    columns() {
      return [
        {
          field: 'name',
          label: 'Audience Name',
        },
        {
          field: 'client.title',
          label: 'Client',
        },
        {
          field: 'scopeDisplay',
          label: 'Type',
        },
        {
          field: (row) => {
            const firstName = row.createdBy && row.createdBy.firstName ? row.createdBy.firstName : '';
            const lastName = row.createdBy && row.createdBy.lastName ? row.createdBy.lastName : '';
            
            return !firstName && !lastName ? "N/A" : firstName.concat(" ", lastName);
          },
          label: 'Created By',
        },
        {
          label: 'Created At',
          field: (props) =>
            format(
              UtcToTimezone(props.createdAt, 'yyyy-MM-dd HH:mm:ss'),
              'DD MMM YYYY h:mm A'
            )
        },
        {
          field: (row) => (row.deleted ? 'Yes' : 'No'),
          label: 'Deleted/Archived',
        },
        {
          field: '---',
          label: 'View Activity Logs',
        },
        {
          field: 'associatedCampaigns',
          label: 'Number of Associated Campaigns',
        },
      ];
    },
    paginationOptions() {
      return {
        enabled: true,
        mode: 'pages',
        perPageDropdownEnabled: false,
        setCurrentPage: this.currentPage,
        perPage: 15
      };
    },
  },
  methods: {
    async getAudiences(payload = {}) {
      const response = await this.request(
        'GET-AUDIENCES',
        AudienceServiceV2.getAdminAudiences,
        payload
      );
      if (response && response.data && response.data.data) {
        this.rows = response.data.data;
        this.totalRows = response.data.meta.total;
      }
    },
    handleLogsClicked(audience) {
      this.showLogsModal = true;
      this.activityLogs = audience.activityLogs;
    },
    handleViewScopeClicked(audience) {
      this.viewAudienceData = audience.assignments;
      this.scopeDisplay = audience.scopeDisplay;
      this.showAudienceAvailabilityModal = true;
    },
    closeAudienceAvailabilityModal() {
      this.showAudienceAvailabilityModal = false;
    },
    closeActivityLogsModal() {
      this.showLogsModal = false;
    },
    handlePageChanged(params) {
      this.getAudiences({page: params.currentPage});
    },
    handleViewCampaignsClicked(audience) {
      this.campaignsModalAudience = audience;
      this.showCampaignsModal = true;
    },
    closeCampaignsModal(){
      this.showCampaignsModal = false;
    }
  },
  mounted() {
    this.registerApis(['GET-AUDIENCES']);
    this.registerApis(['GET-CAMPAIGNS']);
    this.getAudiences();
  },
};
</script>
